import { useState, useEffect } from 'react';

export default function useFetch(service, methodName, filtros) {
  const [fetchState, setFetchState] = useState({
    isLoading: true,
    data: [],
    isFailed: false
  });
  
  useEffect(() => {
    async function fetchData() {
      try {
        setFetchState({
          isLoading:true
        });
        const result = await service[methodName](filtros) 
        setFetchState({
          data: result,
          isFailed: false
        });
      } 
      catch (error) {
        console.log(error)
        setFetchState({          
          data: [],
          isFailed: true});
      } 
      finally {
        setFetchState((prevState) => ({
          ...prevState,
          isLoading: false,
        }));
      }
    }
    fetchData();
  }, [methodName, filtros]);

  return fetchState;
}
